<template>
  <section id="shop_car">
    <div class="head"></div>
    <div class="box">
      <div class="content">
        <p class="title">购物车</p>
        <div class="goods" v-if="goodsList.length">
          <div class="details" v-for="(goods, index) in goodsList" :key="index">
            <div class="left">
              <!--<i class="el-icon-success"></i>-->
              <el-checkbox v-model="checked[index]"></el-checkbox>
              <img :src="goods.product.productImage" alt="">
            </div>
            <div class="middle">
              <span class="type" style="margin-right: 60px;width: 260px;display: inline-block;text-align: left;">{{goods.product.specifications}}/超高亮/{{goods.product.productName}}</span>
              <span class="pic" style="margin-left: 60px;">￥{{goods.product.category.productPrice}}</span>
            </div>
            <div class="right">
              <cartInputNumber style="margin-right: 80px;"
                               :initCount="goods.num"
                               :cartId="goods.cartId"
                               :goodsId="goods.product.productId"
                               v-on:carDataObj="getInputNumer"></cartInputNumber>
              <i class="el-icon-delete" @click="prompt = goods.cartId"></i>
            </div>
            <div class="ask" v-if="prompt === goods.cartId">
              <div class="word">
                <div class="tet">确定删除此商品吗</div>
                <div class="flex">
                  <p class="cancel" @click="prompt = -1">取消</p>
                  <p class="ensure" @click="clear(goods.cartId, goods.num)">确定</p>
                </div>
              </div>
            </div>
          </div>
          <div class="state">
            <!--<div class="go_on">-->
            <!--<i class="el-icon-goods"></i>-->
            <!--<span>继续选购</span>-->
            <!--</div>-->
            <div class="right">
              <!--{{allPirce(goods.num, goods.product.category.productPrice)}}-->
              <p class="text">应付：<span class="rmb">￥<span class="number">{{totalcount | shareNowPrice}}</span></span></p>
              <button @click="goSettlement()">去结算</button>
            </div>
          </div>
        </div>
        <div class="prompt" v-else>
          <img src="../../assets/image/shoppingCart-normal.png" alt="" class="normal">
          <p style="font-family: 'SourceHanSansCN-Normal';margin-top: 33px;">您还没有选择任何商品哦，快去逛逛吧~</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import cartInputNumber from '../common/cartInputNumber.vue'
import {getGoodsObject, upData, removeItem} from '../../common/js/localSg.js'
import {vm, COUNTSTR} from '../../common/js/vm.js'

export default {
  name: 'shopCar',
  inject: ['reload'],
  data () {
    return {
      num: 0,
      num1: 1,
      checked: [],
      goodsList: {},
      prompt: false
    }
  },
  components: {
    cartInputNumber
  },
  computed: {
    totalcount () {
      let that = this
      var trueArr = this.checked.filter(function (goods) { return goods })
      console.log(trueArr)
      var amount = 0
      this.checked.forEach((goods, index) => {
        if (goods) {
          var count = that.goodsList[index].num
          var price = that.goodsList[index].product.category.productPrice
          var itemamount = count * price
          amount += itemamount
          // that.addItem(that.goodsList[index])
        }
      })
      return amount
    }
  },
  methods: {
    getInputNumer (resObj) {
      let that = this
      upData(resObj)
      for (var i = 0; i < that.goodsList.length; i++) {
        if (that.goodsList[i].cartId === resObj.cartId) {
          if (resObj.type === 'add') {
            this.goodsList[i].num = this.goodsList[i].num + 1
          } else {
            this.goodsList[i].num = this.goodsList[i].num - 1
            if (this.goodsList[i].num < 1) {
              this.goodsList[i].num = 1
            }
          }
          break
        }
      }
    },
    handleChange (value) {
      console.log(value)
    },
    clear (cartId) {
      removeItem(cartId)
      var obj = getGoodsObject()
      for (var key in obj) {
        if (key === cartId) {
          delete obj[key]
        }
      }
      console.log(obj, '啦啦啦')
      vm.$emit(COUNTSTR, -1)
      let that = this
      that.axios.post('/cart/del', {
        cartId: cartId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$nextTick(() => {
            that.getGoodsList()
            that.prompt = false
          })
          // var n = localStorage.getItem('c')
          // localStorage.setItem('c', n - 1)
          that.reload()
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    getGoodsList () {
      let that = this
      if (!that.$root.getUserId()) {
        that.$store.commit('setToastMsg', '请登录')
        that.$router.push('/login')
        return
      }
      var obj = getGoodsObject()
      console.log(obj)
      that.axios.post('/cart/list', {
        userId: that.$root.getUserId()
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true// 需要转json
      }).then(function (response) {
        if (response.data.status === 0) {
          console.log(response.data.value)
          response.data.value.forEach((item) => {
            item.num = obj[item.cartId]
            if (item.num === 'undefined') {
              that.clear(item.cartId)
            }
            that.checked.push(false)
          })
          that.goodsList = response.data.value
          localStorage.setItem('c', response.data.value.length)
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    // allPirce () {
    //   var res = 0
    //   for (var i = 0; i < this.goodsList.length; i++) {
    //     var pic = this.goodsList[i].product.category.productPrice * this.goodsList[i].num
    //     res += pic
    //   }
    //   return res
    // },
    addItem (value) {
      var KEY = 'goods'
      var jsonString = localStorage.getItem(KEY)
      jsonString = jsonString || '[]'
      var arr = JSON.parse(jsonString)
      arr.push(value)
      // 将arr转换成json字符串保存起来
      localStorage.setItem(KEY, JSON.stringify(arr))
    },
    goSettlement () {
      let that = this
      var trueArr = that.checked.filter(function (goods) { return goods })
      if (trueArr === undefined || trueArr.length === 0) {
        that.$store.commit('setToastMsg', '您还没选择要购买的商品')
        return
      }
      var amount = 0
      this.checked.forEach((goods, index) => {
        if (goods) {
          var count = that.goodsList[index].num
          var price = that.goodsList[index].product.category.productPrice
          var itemamount = count * price
          amount += itemamount
          that.addItem(that.goodsList[index])
        }
      })
      console.log(amount)
      that.$router.push('/shoppingCar/settlement')
    }
  },
  created () {
    this.getGoodsList()
  }
}
</script>

<style scoped>
  #shop_car{
    padding-bottom: 60px;
    background-color: #f0f0f0;
    box-sizing: border-box;
  }
  .head{
    height: 52px;
    background-color: #fff;
    margin-bottom: 60px;
  }
  .box{
    width: 1201px;
    /*height: 536px;*/
    min-height: 536px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #FFFFFF;
    overflow: auto;
  }
  .content{
  }
  .content .title{
    text-align: left;
    padding: 39px 40px 29px 40px;
    font-size: 18px;
    font-family: "SourceHanSansCN-Medium";
    color: #333;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
  }
  .content .goods{
    padding: 0 40px;
  }
  .content .goods .details{
    height: 123px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e5e5;
  }
  .content .goods .details .left{
    display: flex;
    align-items: center;
  }
  .el-icon-success{
    color: #05b570;
  }
  .content .goods .details .left>img{
    width: 100px;
    height: 100px;
    margin-left: 15px;
  }
  .content .goods .details .middle>span{
    color: #333;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content .goods .details .right{
    display: flex;
    align-items: center;
    margin-right: 30px;
  }
  .el-icon-delete{
    font-size: 20px;
    color: #999;
    cursor: pointer;
  }
  .prompt{
    padding: 60px;
    font-size: 20px;
    font-family: "SourceHanSansCN-Normal";
  }
  /*---------删除弹窗样式-------------*/
  .ask{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.3);
    text-align: center;
    z-index: 999;
  }
  .ask .word{
    width: 600px;
    height: 200px;
    padding: 30px;
    margin: 100px auto;
    box-sizing: border-box;
    background-color: #fff;
  }
  .ask .cancel,
  .ask .ensure{
    width: 100px;
    height: 40px;
    line-height: 40px;
    color: #000;
    cursor: pointer;
    border: 1px solid #ccc;
  }
  .ask .ensure{
    background-color: #ddd;
  }
  .ask .flex{
    width: 260px;
    margin: 80px auto;
    display: flex;
    justify-content: space-between;
  }
  .content .state{
    padding: 40px;
    box-sizing: border-box;
  }
  .content .state .go_on{
    text-align: left;
    font-size: 16px;
    margin-top: 51px;
    color: #292b31;
  }
  .content .state .go_on>span{
    font-family: "SourceHanSansCN-Normal";
  }
  .content .state .right{
    font-size: 16px;
    text-align: right;
    padding-bottom: 30px;
    box-sizing: border-box;
  }
  .content .state .right .text{
    font-family: "SourceHanSansCN-Normal";
  }
  .content .state .right .rmb{
    font-size: 23px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content .state .right .number{
    font-size: 30px;
    font-family: "SourceHanSansCN-Normal";
  }
  .content .state .right button{
    width: 196px;
    height: 55px;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal";
    line-height: 55px;
    margin-top: 26px;
    color: #FFFFFF;
    background-color: #05b570;
    border-radius: 2px;
    cursor: pointer;
    /*margin-bottom: 20px;*/
  }
  .normal{
    width: 67px;
    height: 57px;
    margin-top: 30px;
  }
</style>
<style>
  .el-checkbox__inner::after{
    box-sizing: content-box;
    content: "";
    border: 2px solid #ffffff;
    border-left: 0;
    border-top: 0;
    height: 12px !important;
    left: 8px !important;
    top: 3px !important;
    position: absolute;
    -webkit-transform: rotate(45deg) scaleY(0);
    transform: rotate(45deg) scaleY(0);
    width: 4px !important;
    transition: transform .15s ease-in .05s,-webkit-transform .15s ease-in .05s;
    -webkit-transform-origin: center;
    transform-origin: center;
  }
  #shop_car span.el-checkbox__inner {
    height:24px;
    width:24px;
    border-radius: 50%;
    border-color: #ccc;
  }
  #shop_car span.el-checkbox__inner:hover {
    border-color: #05b570;
  }
  #shop_car .el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-indeterminate .el-checkbox__inner{
    height:24px;
    width:24px;
    background-color: #05b570 !important;
    border-color:#05b570;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingCar/shopCar.vue